// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"5093ab12","767":"091a2f7d"}[chunkId] + ".chunk.js";
};